exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".WahooFlow-e01a62e1{position:relative}.WahooFlow-e01a62e1 .instructions-44f0de92{text-align:center;max-width:500px;margin:0 auto}.WahooFlow-e01a62e1 .centeredImg-0c02e065{text-align:center;margin:20px 0}\n", ""]);

// Exports
exports.locals = {
	"WahooFlow": "WahooFlow-e01a62e1",
	"instructions": "instructions-44f0de92",
	"centeredImg": "centeredImg-0c02e065"
};